import isGoogleVerificationMode from './googleVerificationMode'

const _active = isGoogleVerificationMode()

const isInitAppDebugEnabled = (): boolean => _active

export default isInitAppDebugEnabled
